import type { ListArgusScheduleRunsResponse } from "../../types/argus";
import { useApiQuery } from "../use-api-query";

interface UseListArgusScheduleRunsOptions {
  enabled?: boolean;
  limit?: number;
}

export function useListArgusScheduleRuns(
  scheduleId: string | undefined,
  options: UseListArgusScheduleRunsOptions = {},
) {
  const { enabled = true, limit = 20 } = options;

  return useApiQuery<ListArgusScheduleRunsResponse>(
    `/client/argus/schedules/${scheduleId}/runs?limit=${limit}`,
    {
      enabled: enabled && !!scheduleId,
      refetchInterval: 5_000,
    },
  );
}
